import { Image } from "lucide-react"

export const ImagePlaceholder = () => (
  <div
    className="flex aspect-square size-full items-center justify-center bg-gray-200"
    data-testid="ImagePlaceholder"
  >
    <Image className="size-1/4 text-gray-50" />
  </div>
)
